////
/// ============================================================================
/// COMPONENT / Swiper Gallery
/// ============================================================================
///
/// @group components
////

import Swiper from 'swiper';
import { Navigation, Thumbs } from 'swiper/modules';

export default () => {
    document.querySelectorAll('.js-gallery').forEach(el => {
        let swiperThumb = new Swiper(el.querySelector('.js-gallery-thumb'), {
            spaceBetween: 10,
            slidesPerView: 'auto'
        });

        new Swiper(el.querySelector('.js-gallery-main'), {
            modules: [Navigation, Thumbs],
            spaceBetween: 0,
            autoHeight: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            thumbs: {
                swiper: swiperThumb,
            }
        });
    });
};
